import { render } from "./AddSSHCollector.vue?vue&type=template&id=066d81d5"
import script from "./AddSSHCollector.vue?vue&type=script&lang=js"
export * from "./AddSSHCollector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__